import React from 'react';
import generalDentistryImg from '../../assets/generalDentistryImg.jpg';
import cosmeticDentistryImg from '../../assets/cosmeticDentistryImg.webp';
import oralSurgeyImg from '../../assets/oralSurgeryImg.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTooth, faMagic, faProcedures, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router';

const DentalServices = () => {
  const navigate = useNavigate();

  const services = [
    {
      title: "General Dentistry",
      description: "Healthy smiles start here! From routine cleanings and fillings to x-rays and preventive care, we offer complete dental solutions to keep your teeth strong and bright.",
      buttonText: "ABOUT GENERAL DENTISTRY",
      image: generalDentistryImg,
      icon: faTooth,
      link: '/general'
    },
    {
      title: "Cosmetic Dentistry",
      description: "Enhance your smile with our cosmetic treatments! From Invisalign and veneers to professional teeth whitening, we help you achieve a confident, radiant look.",
      buttonText: "ABOUT COSMETIC DENTISTRY",
      image: cosmeticDentistryImg,
      icon: faMagic,
      link: '/cosmetic'
    },
    {
      title: "Oral Surgery",
      description: "Expert care for a healthier smile! From extractions to implants and advanced surgical procedures, we restore function and confidence with precision and care.",
      buttonText: "ABOUT ORAL SURGERY",
      image: oralSurgeyImg,
      icon: faProcedures,
      link: '/surgical'
    }
  ];

  return (
    <div className="w-full mx-auto px-4 md:px-20 py-16 gap-4 bg-gradient-to-b from-teal-50 to-white relative overflow-hidden">
      {/* Decorative elements inspired by the logo */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-lime-400 opacity-10 rounded-full transform translate-x-32 -translate-y-32"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-teal-500 opacity-10 rounded-full transform -translate-x-24 translate-y-24"></div>
      
      <div className="text-center mb-12 relative z-10">
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-teal-700 mb-4">
          Our Comprehensive Dental Services
        </h2>
        <p className="text-slate-600 max-w-3xl mx-auto text-lg">
          Providing exceptional dental care with cutting-edge technology and a patient-centered approach, all in one convenient location.
        </p>
      </div>

      {/* Service Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16 relative z-10">
        {services.map((service, index) => (
          <div
            key={index}
            className="h-[450px] rounded-2xl overflow-hidden shadow-lg transition-all duration-300 hover:-translate-y-2 hover:shadow-xl bg-white relative"
          >
            {/* Card Top Accent */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-teal-500 to-lime-400"></div>
            
            {/* Image Section */}
            <div className="h-48 w-full overflow-hidden relative">
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
              />
              {/* Floating Icon */}
              <div className="absolute -bottom-8 right-6 w-16 h-16 rounded-full bg-gradient-to-br from-teal-500 to-teal-600 flex items-center justify-center shadow-md transform transition-transform duration-300 hover:rotate-12">
                <FontAwesomeIcon icon={service.icon} className="text-white text-2xl" />
              </div>
            </div>

            {/* Content Section */}
            <div className="p-6 pt-10">
              <h3 className="text-xl font-bold text-teal-700 mb-4">
                {service.title}
              </h3>
              <p className="text-slate-600 mb-6 text-sm leading-relaxed line-clamp-3">
                {service.description}
              </p>
              <Link
                to={service.link}
                className="inline-block px-5 py-2 rounded-full transition-all duration-300 text-white text-sm font-medium bg-gradient-to-r from-lime-500 to-lime-400 hover:from-lime-600 hover:to-lime-500 shadow-md hover:shadow-lg"
              >
                Learn More
              </Link>
            </div>
          </div>
        ))}
      </div>

      {/* Explore More Button */}
      <div className="text-center mt-8 relative z-10">
        <button onClick={() => navigate('/service')}
          className="cursor-pointer inline-flex items-center px-8 py-4 font-semibold rounded-full shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-xl text-white bg-gradient-to-r from-teal-500 to-lime-500 hover:from-teal-600 hover:to-lime-600"
        >
          Explore All Services
          <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
        </button>
      </div>

      {/* Service Indicators */}
      <div className="flex justify-center gap-2 mt-10 relative z-10">
        <div className="w-12 h-1 bg-teal-500 rounded-sm"></div>
        <div className="w-8 h-1 bg-lime-400 rounded-sm"></div>
        <div className="w-8 h-1 bg-teal-300 rounded-sm"></div>
        <div className="w-8 h-1 bg-lime-300 rounded-sm"></div>
      </div>
    </div>
  );
};

export default DentalServices;